"use client";

import { usePathname } from "next/navigation";

const MainWrapper = ({ children }) => {
  const pathname = usePathname();
  const isHome = pathname === "/";

  return (
    <main className={isHome ? "md:mt-[64px]" : ""}>
      {children}
    </main>
  );
};

export default MainWrapper;
